const doc = [({"ja":({"adminConstantInventoryUnit":({"room":"部屋増減", "guest":"人数増減"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;